<!-- Zweck: Stellt die HTML-Struktur für dashboard widgets shop views component im Frontend bereit. -->
<dashboard-widget>
  <div icon>
    <svg-icon>shop</svg-icon>
  </div>
  <div header1 matTooltip="Shops">
    Shops
  </div>
  <div content>
    <div class="menuboxouter tut_shopmenu_views">
      <div class="menubox menubox_small">
        @for (v of views; track v) {
          @if (v.allowed) {
            <a class="button mat-raised-button" routerLink="/shop/{{v.slug}}"
              [style.color]="v.getFontColor()" [class.hovertransparent]="v.getBGColor() != ''"
              routerLinkActive="active-link">
              <div [style.background-color]="v.getBGColor()" >
                <div style="padding:1rem;">
                  <svg-icon size="40">{{v.getIcon()}}</svg-icon>
                  <div>{{v.getLabel()}}</div>
                </div>
              </div>
            </a>
          }
          @if (!v.allowed) {
            <a class="button disabled mat-raised-button"
              [style.background-color]="v.getBGColor()" [style.color]="v.getFontColor()" [class.hovertransparent]="v.getBGColor() != ''"
              routerLinkActive="active-link">
              <div>
                <svg-icon size="40">{{v.getIcon()}}</svg-icon>
                {{v.getLabel()}}
                <br>
                  Keine Berechtigung
                </div>
              </a>
            }
          }

          @if (views && views.length == 0) {
            <div class="infobox" style="text-align: center">
              <h1>
                <info-box type="shop_menu_no_views"></info-box>
              </h1>
            </div>
          }
        </div>
      </div>
    </div>
  </dashboard-widget>
